import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Zap } from 'lucide-react';

const XPAnimation = ({ show, xpAmount, position = { x: '50%', y: '50%' } }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 0, scale: 0.5 }}
          animate={{ 
            opacity: [1, 1, 0], 
            y: -100, 
            scale: [0.5, 1.2, 1]
          }}
          exit={{ opacity: 0 }}
          transition={{ duration: 2 }}
          className="fixed z-50 pointer-events-none"
          style={{ left: position.x, top: position.y }}
        >
          <div className="flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-600 
                          text-white px-4 py-2 rounded-full shadow-xl">
            <Zap className="w-5 h-5" />
            <span className="font-bold text-lg">+{xpAmount} XP</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default XPAnimation;
